import { render, staticRenderFns } from "./IntranetNavContentLinkExact.vue?vue&type=template&id=1ddfa8d8&scoped=true&"
import script from "./IntranetNavContentLinkExact.vue?vue&type=script&lang=js&"
export * from "./IntranetNavContentLinkExact.vue?vue&type=script&lang=js&"
import style0 from "./IntranetNavContentLinkExact.vue?vue&type=style&index=0&id=1ddfa8d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddfa8d8",
  null
  
)

export default component.exports